import React from "react"
import { Link } from "gatsby"
import styles from "./styles/index.module.scss"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { useStaticQuery, graphql } from "gatsby"

import heroImg from "../images/hero.png"
import heroBgImg from "../images/hero-bg.png"
import profileImg from "../images/profile.png"
import illustImg from "../images/illust.png"

const pageQuery = graphql`
  {
    gcms {
      texts {
        profile
        statusOfCommission
        termsOfUse {
          html
        }
        contact {
          html
        }
      }
    }
  }
`

const IndexPage = () => {
  const {
    gcms: { texts },
  } = useStaticQuery(pageQuery)
  return (
    <Layout>
      <SEO title="逢編いあむのホームページ" />

      <div className={styles.hero}>
        <div className={styles.titles}>
          <h1>逢編いあむ</h1>
          <h2>Aiam iam</h2>
        </div>
        <img src={heroBgImg} alt="" className={styles.heroBg} />
        <img src={heroImg} alt="" className={styles.heroImg} />
      </div>

      <nav>
        <ul>
          <li>
            <a href="#illustration">
              <div className={styles.title}>イラスト</div>
              <div className={styles.subtitle}>illustration</div>
            </a>
          </li>
          <li>
            <a href="#movie">
              <div className={styles.title}>映像作品</div>
              <div className={styles.subtitle}>movie</div>
            </a>
          </li>
          <li>
            <a href="#profile">
              <div className={styles.title}>逢編いあむ</div>
              <div className={styles.subtitle}>about</div>
            </a>
          </li>
          <li>
            <a href="#terms">
              <div className={styles.title}>作品使用について</div>
              <div className={styles.subtitle}>terms of use</div>
            </a>
          </li>
          <li>
            <a href="#status-of-commission">
              <div className={styles.title}>お仕事受付状況</div>
              <div className={styles.subtitle}>status of commission</div>
            </a>
          </li>
          <li>
            <a href="#contact">
              <div className={styles.title}>ご連絡</div>
              <div className={styles.subtitle}>contact</div>
            </a>
          </li>
        </ul>
      </nav>
      <section class={styles.illustration} id="illustration">
        <h2>イラスト</h2>
        <div className={styles.box}>
          <img src={illustImg} alt="" className={styles.illust} />
          <a href="https://instagram.com/iamuu_n" className={styles.viewMore}>
            Instagramで作品を見る →
          </a>
        </div>
      </section>
      <section id="movie">
        <h2>映像作品</h2>
        <div className={styles.box}>
          <div className={styles.youtube}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/xLkFCQOMIm0"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              title="Video"
            ></iframe>
          </div>
          <div className={styles.youtube}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/K3SAI5r6eT8"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </section>
      <section id="terms">
        <h2>作品使用について</h2>
        <div
          className={styles.box}
          dangerouslySetInnerHTML={{ __html: texts[0].termsOfUse.html }}
        />
        <div className={styles.box}>
          <p>
            使用報告は任意ですが、していただけると喜びます。(DM、リプライ、引用リツイートなどにて)
            その他何か心配な点がありましたらDMなどで連絡していただければ答えます。
          </p>

          <p>
            (不可以商业使用。
            如果您可以写下我画的内容以及我的姓名(逢編いあむ)或TwitterID(
            <a href="https://twitter.com/iamuu_n">@iamuu_n</a>
            )，则可以进行转换。)
          </p>

          <p>
            (Please do not commercial use. If you use my works,describe that's
            drawing by me(逢編いあむ or{" "}
            <a href="https://twitter.com/iamuu_n">@iamuu_n</a>).)
          </p>
        </div>
      </section>
      <section className={styles.profile} id="profile">
        <h2>プロフィール</h2>
        <div className={styles.box}>
          <img src={profileImg} alt="" className={styles.profileImg} />
          <p className={styles.text}>{texts[0].profile}</p>
        </div>
        <div className={styles.links}>
          <ul>
            <li>
              <a href="http://twitter.com/iamuu_n">twitter</a>
            </li>
            <li>
              <a href="https://pixiv.me/iamuu_n">pixiv</a>
            </li>
            <li>
              <a href="https://aiamiam.booth.pm">BOOTH</a>
            </li>
            <li>
              <a href="https://instagram.com/iamuu_n">instagram</a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCcpO0J-EAzfSCG4JA19G28A">
                YouTube
              </a>
            </li>
            <li>
              <a href="https://iamuu-n.fanbox.cc/">FANBOX</a>
            </li>
          </ul>
        </div>
      </section>
      <section id="status-of-commission">
        <h2>お仕事受付状況</h2>
        <div className={styles.box}>
          <p>ご依頼は有償のもののみお受けしております、ご了承ください。</p>
          <p>―ただいまのご依頼状況―</p>
          <p className={styles.text}>{texts[0].statusOfCommission}</p>
        </div>
      </section>
      <section id="contact">
        <h2>ご連絡</h2>
        <div
          className={styles.box}
          dangerouslySetInnerHTML={{ __html: texts[0].contact.html }}
        />
      </section>
    </Layout>
  )
}

export default IndexPage
